import { Box, Image, TextNew } from '@jfs/ui-new'
import { openPlayStore } from '../../comps/ProductsMegaMenu'
import { style } from './FaqFooterStyle'

interface FaqFooterProps {
  respPadding: number
  isMobile: boolean
}

export const FaqFooter = ({ respPadding, isMobile }: FaqFooterProps) => {
  const styles = style(respPadding, isMobile)
  return (
    <Box {...styles.superView}>
      <Box {...styles.mainContainer}>
        <Box {...styles.jioBizImageContainer}>
          <Image
            resizeMode="contain"
            source={require('../../assets/images/jio-pay.png')}
            width={isMobile ? 120 : 150}
            height={isMobile ? 110 : 140}
          />
        </Box>
        <Box {...styles.textAndIcon}>
          <Box {...styles.textContainer}>
            <TextNew {...styles.normalText}>
              {'Download '}
              <TextNew {...styles.blueBoldText}>{'Jiopay Business App '} </TextNew>
              <TextNew {...styles.normalText}>{'on Google Play store to view transaction history'} </TextNew>
            </TextNew>
          </Box>
          <Box {...styles.underlayTrans} onPress={openPlayStore}>
            <Image
              source={require('../../assets/images/google-play.png')}
              {...styles.imgStyle}
              resizeMode={'contain'}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
